<template>
  <div class="mail_list">
    <section class="text_center no_padding">
      <h2 class="header_underline">メールBOX一覧</h2>

      <ul class="mail_list_box pl-0">
        <li
          :class="{
            mail_list_box_new: true,
            active: user.messageUnreadCount > 0
          }"
        ><router-link :to="{ name: 'MailThreadsNew' }" class="menu_list_font--text">
          <v-icon color="menu_list_font">mdi-email-outline</v-icon>
          <span class="mail_list_box_title">新着メールBOX</span>
          <span class="mail_list_box_subtitle">現在新着メールは<span :class="{ active: user.messageUnreadCount > 0 }">{{ user.messageUnreadCount }}</span>件です</span>
        </router-link></li>
        <li class="mail_list_box_received"><router-link :to="{ name: 'MailThreadsReceived' }" class="menu_list_font--text">
          <v-icon color="menu_list_font">mdi-send-variant-outline</v-icon>
          <span class="mail_list_box_title">送信メールBOX</span>
          <span class="mail_list_box_subtitle">鑑定師に送信したメールはこちら</span>
        </router-link></li>
        <li class="mail_list_box_read"><router-link :to="{ name: 'MailThreadsRead' }" class="menu_list_font--text">
          <v-icon color="menu_list_font">mdi-email-open-outline</v-icon>
          <span class="mail_list_box_title">既読メールBOX</span>
          <span class="mail_list_box_subtitle">過去に一度読んだメールはこちら</span>
        </router-link></li>
        <li><router-link :to="{ name: 'SupportBox' }" class="menu_list_font--text">
          <v-icon color="menu_list_font">mdi-message-question-outline</v-icon>
          <span class="mail_list_box_title">サポートメッセージBOX</span>
          <span class="mail_list_box_subtitle">
            <template v-if="user.supportUnreadCount > 0">
              <span class="active">新しいお問い合わせメッセージがあります</span>
            </template>
            <template v-else>お問い合わせのメッセージはこちら</template>
          </span>
        </router-link></li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MailList',
  data () {
    return {
      user: this.$store.getters.loginUser || null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    }
  }
}
</script>
